/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GeoCampaignDTO } from './geoCampaignDTO';
import { GeoTestRegionsDataDTO } from './geoTestRegionsDataDTO';
import { GeoTestScheduleDTO } from './geoTestScheduleDTO';


export interface GeoTestSaveRequestDTO { 
    /**
     * Measured client identifier. Use the client ID returned by the authenticated context.
     */
    clientId: number;
    /**
     * Brand identifier within the client. Use this together with clientId when a request targets a specific brand.
     */
    brandId: number;
    /**
     * Target status for the test (DRAFT or ACTIVE)
     */
    status: GeoTestSaveRequestDTO.StatusEnum;
    /**
     * User-defined name for the geo test
     */
    testName: string;
    /**
     * Optional business question the test is designed to answer
     */
    businessQuestion?: string;
    /**
     * List of selected tactic identifiers for the test
     */
    selectedTacticIds: Array<string>;
    /**
     * List of conversion type IDs to measure in the test
     */
    conversionTypeIds: Array<number>;
    /**
     * Human-readable names for the selected conversion types
     */
    conversionTypeNames: Array<string>;
    testRegions: GeoTestRegionsDataDTO;
    /**
     * List of campaigns included in the test
     */
    campaigns: Array<GeoCampaignDTO>;
    /**
     * Reference period start date in ISO-8601 format for historical data
     */
    referenceStartDate?: string;
    /**
     * Reference period end date in ISO-8601 format for historical data
     */
    referenceEndDate?: string;
    testSchedule?: GeoTestScheduleDTO;
    /**
     * Execution method for the test (e.g. MANAGED or SELF_SERVE)
     */
    executionMethod?: GeoTestSaveRequestDTO.ExecutionMethodEnum;
    /**
     * ID of the recommendation this test was created from, if applicable
     */
    recommendationId?: number;
    /**
     * Platform vendor for test execution
     */
    vendor?: string;
    /**
     * Estimated daily scale cost for scale-type tests
     */
    scaleCost?: number;
    /**
     * Account types for platform configuration matching
     */
    accountTypes?: Array<string>;
}
export namespace GeoTestSaveRequestDTO {
    export type StatusEnum = 'DRAFT' | 'ACTIVE' | 'INACTIVE';
    export const StatusEnum = {
        Draft: 'DRAFT' as StatusEnum,
        Active: 'ACTIVE' as StatusEnum,
        Inactive: 'INACTIVE' as StatusEnum
    };
    export type ExecutionMethodEnum = 'AUTOMATIC' | 'MANUAL';
    export const ExecutionMethodEnum = {
        Automatic: 'AUTOMATIC' as ExecutionMethodEnum,
        Manual: 'MANUAL' as ExecutionMethodEnum
    };
}


